import { render, staticRenderFns } from "./PromotionsCard.vue?vue&type=template&id=341124b2&scoped=true"
import script from "./PromotionsCard.vue?vue&type=script&lang=js"
export * from "./PromotionsCard.vue?vue&type=script&lang=js"
import style0 from "./PromotionsCard.vue?vue&type=style&index=0&id=341124b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341124b2",
  null
  
)

export default component.exports